import Component from './index';
import { NAME } from './constants';
import sagas from './sagas';
import reducers from './reducers';
import searchSagas from '../search/sagas';

export default {
  Component,
  name: NAME,
  sagas,
  searchSagas,
  reducers,
};
